import React from 'react';
import { Link } from 'react-router-dom';
import Icon, { IconName } from '../Icon/Icon';
import './StatePage.css';

type StatePageProps = {
  icon: IconName;
  eyebrow?: string;
  title: string;
  text?: string;
  actionLabel?: string;
  actionTo?: string;
  tone?: 'default' | 'error';
  children?: React.ReactNode;
  actionOnClick?: () => void;
};

const StatePage = ({ icon, eyebrow, title, text, actionLabel, actionTo = '/', tone = 'default', children, actionOnClick }: StatePageProps) => (
  <section className="state-page">
    <div className="state-page-shape" aria-hidden="true" />
    <div className="state-page-card lis-reveal">
      <span className={`state-page-icon${tone === 'error' ? ' state-page-icon--error' : ''}`}><Icon name={icon} /></span>
      {eyebrow && <p className="lis-eyebrow">{eyebrow}</p>}
      <h1>{title}</h1>
      {text && <p>{text}</p>}
      {children}
      {actionLabel && <Link to={actionTo} className="lis-button lis-button--primary" onClick={actionOnClick}><Icon name="home" className="lis-inline-icon" />{actionLabel}</Link>}
    </div>
  </section>
);

export default StatePage;
